(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel(sectionEl) {
      var viewport = sectionEl.querySelector('[data-eg-rc-viewport]');
      var track = sectionEl.querySelector('[data-eg-rc-track]');
      if (!viewport || !track) return;
      var slides = track.querySelectorAll('.eg-rc__slide');
      if (!slides.length) return;
      var dots = sectionEl.querySelectorAll('.eg-rc__dot');
      var prevBtn = sectionEl.querySelector('.eg-rc__arrow--prev');
      var nextBtn = sectionEl.querySelector('.eg-rc__arrow--next');

      var autoplaySeconds = parseInt(sectionEl.dataset.autoplaySeconds, 10) || 6;
      var mobileMQ = window.matchMedia('(max-width: 768px)');
      var motionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

      var timer = null;
      var currentIndex = 0;

      function slideStep() {
        if (!slides[0]) return 0;
        var w = slides[0].getBoundingClientRect().width;
        var trackStyle = window.getComputedStyle(track);
        var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
        return w + gap;
      }

      function visibleCount() {
        var step = slideStep();
        if (!step) return 1;
        return Math.max(1, Math.round(viewport.clientWidth / step));
      }

      function maxIndex() {
        return Math.max(0, slides.length - visibleCount());
      }

      function goTo(index, behavior) {
        var max = maxIndex();
        if (index > max) index = 0;
        if (index < 0) index = max;
        currentIndex = index;
        viewport.scrollTo({ left: index * slideStep(), behavior: behavior || 'smooth' });
        updateDots();
      }

      function next() { goTo(currentIndex + 1); }
      function prev() { goTo(currentIndex - 1); }

      function updateDots() {
        dots.forEach(function(dot, i) {
          if (i === currentIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function syncFromScroll() {
        var step = slideStep();
        if (!step) return;
        var idx = Math.round(viewport.scrollLeft / step);
        var clamped = Math.min(Math.max(idx, 0), maxIndex());
        if (clamped !== currentIndex) {
          currentIndex = clamped;
          updateDots();
        }
      }

      function autoplayAllowed() {
        return !mobileMQ.matches && !motionMQ.matches;
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplayAllowed()) return;
        timer = window.setInterval(next, autoplaySeconds * 1000);
      }

      function stopAutoplay() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      if (nextBtn) nextBtn.addEventListener('click', function() { next(); resetAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function() { prev(); resetAutoplay(); });
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.index, 10) || 0);
          resetAutoplay();
        });
      });

      sectionEl.addEventListener('mouseenter', stopAutoplay);
      sectionEl.addEventListener('mouseleave', startAutoplay);
      sectionEl.addEventListener('focusin', stopAutoplay);
      sectionEl.addEventListener('focusout', startAutoplay);

      var scrollT = null;
      viewport.addEventListener('scroll', function() {
        if (scrollT) clearTimeout(scrollT);
        scrollT = setTimeout(syncFromScroll, 100);
      }, { passive: true });

      var resizeT = null;
      window.addEventListener('resize', function() {
        if (resizeT) clearTimeout(resizeT);
        resizeT = setTimeout(function() {
          startAutoplay();
          syncFromScroll();
        }, 150);
      });

      updateDots();
      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('.eg-rc').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(e) {
      var sectionEl = e.target.querySelector('.eg-rc');
      if (sectionEl) initCarousel(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-business"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bp').forEach(function (section) {
    // File-upload label swap on selection
    var fileInput = section.querySelector('.bp__file-input');
    if (fileInput) {
      var fileLabel = section.querySelector('.bp__file-label');
      var fileWrap = section.querySelector('.bp__file');
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) {
          fileLabel.textContent = fileInput.files[0].name;
          fileWrap.classList.add('has-file');
        }
      });
    }

    // Scroll to success message after form submit
    var successEl = section.querySelector('.bp__form-success');
    if (successEl && window.location.hash !== '#bp-quote') {
      setTimeout(function () {
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.cp');
  sections.forEach(function (section) {
    var openBtn = section.querySelector('.cp__mobile-open');
    var closeBtn = section.querySelector('.cp__mobile-close');
    var backdrop = section.querySelector('.cp__rail-backdrop');
    var form = section.querySelector('#CollectionFiltersForm');

    function open() {
      section.classList.add('cp--filters-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      section.classList.remove('cp--filters-open');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    // Auto-submit form on filter or sort change
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) {
          form.submit();
        }
      });
      // Debounced submit on price-range typing
      var priceTimer;
      form.addEventListener('input', function (e) {
        if (e.target.matches('input[type="number"]')) {
          clearTimeout(priceTimer);
          priceTimer = setTimeout(function () { form.submit(); }, 700);
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ct').forEach(function (section) {
    var segmented = section.querySelector('.ct__segmented');
    var conditional = section.querySelector('#ContactOrderField');
    if (!segmented) return;

    function update(activeValue) {
      // Visual: swap is-active class
      segmented.querySelectorAll('.ct__seg').forEach(function (seg) {
        seg.classList.toggle('is-active', seg.dataset.inquiry === activeValue);
      });
      // Reveal/hide order-number field
      if (conditional) {
        conditional.hidden = activeValue !== 'order-support';
      }
    }

    // Initial state on load (in case form was submitted with order-support)
    var checked = segmented.querySelector('input[type="radio"]:checked');
    if (checked) {
      var initialLabel = segmented.querySelector('label input[value="' + checked.value + '"]');
      if (initialLabel) {
        var parent = initialLabel.closest('.ct__seg');
        if (parent) update(parent.dataset.inquiry);
      }
    }

    // Click handlers (label wraps the radio, so click bubbles correctly)
    segmented.querySelectorAll('.ct__seg').forEach(function (seg) {
      seg.addEventListener('click', function () {
        var radio = seg.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          update(seg.dataset.inquiry);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cr').forEach(function (section) {

    // --- Filter pills ---
    var pills = section.querySelectorAll('.cr__pill');
    var cards = section.querySelectorAll('.cr__card');
    var emptyState = section.querySelector('[id^="CrEmpty-"]');

    function applyFilter(filter) {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var rating = parseInt(card.getAttribute('data-rating') || '5', 10);
        var hasPhoto = card.getAttribute('data-has-photo') === 'true';
        var show = true;
        if (filter === '5') show = rating === 5;
        else if (filter === 'photos') show = hasPhoto;
        card.hidden = !show;
        if (show) visibleCount++;
      });
      if (emptyState) emptyState.hidden = visibleCount > 0;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        applyFilter(pill.getAttribute('data-filter'));
      });
    });

    // --- Star rating picker ---
    var picker = section.querySelector('.cr__rating-picker');
    if (picker) {
      var stars = picker.querySelectorAll('.cr__rating-star');
      var hiddenInput = section.querySelector('[id^="CrRatingInput-"]');
      var valueDisplay = picker.querySelector('.cr__rating-value');

      function setRating(value) {
        stars.forEach(function (star) {
          var v = parseInt(star.getAttribute('data-value'), 10);
          star.classList.toggle('is-filled', v <= value);
        });
        if (hiddenInput) hiddenInput.value = value;
        if (valueDisplay) valueDisplay.textContent = value;
      }

      stars.forEach(function (star) {
        star.addEventListener('click', function () {
          setRating(parseInt(star.getAttribute('data-value'), 10));
        });
      });
    }

    // --- File upload label ---
    var fileInput = section.querySelector('.cr__file-input');
    if (fileInput) {
      var fileLabel = section.querySelector('.cr__file-label');
      var fileWrap = section.querySelector('.cr__file');
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) {
          fileLabel.textContent = fileInput.files[0].name;
          fileWrap.classList.add('has-file');
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-why-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.wb').forEach(function (section) {
    var tocLinks = section.querySelectorAll('.wb__toc-link');
    var pillars = section.querySelectorAll('.wb__pillar');
    if (!tocLinks.length || !pillars.length || !('IntersectionObserver' in window)) return;

    var linksByTarget = {};
    tocLinks.forEach(function (link) {
      var target = link.getAttribute('data-target');
      if (target) linksByTarget[target] = link;
    });

    function setActive(id) {
      tocLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-target') === id);
      });
    }

    // Scrollspy — track which pillar is in the middle band of the viewport
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive(entry.target.id);
        }
      });
    }, { rootMargin: '-30% 0px -50% 0px', threshold: 0 });

    pillars.forEach(function (pillar) {
      if (pillar.id) observer.observe(pillar);
    });

    // Scroll the active TOC link into view inside the horizontal strip
    tocLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        // Native smooth scroll handles the page jump via scroll-behavior CSS.
        // After click, briefly mark active immediately for snappier feedback.
        var target = link.getAttribute('data-target');
        if (target) setActive(target);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
